import axios from './axiosConfig'; 

const API_URL = '/auth/';

const login = async (username, password) => {
    const response = await axios.post(API_URL + 'login', {username, password});
    if(response.data.token){
        localStorage.setItem('token', response.data.token);
        const decodedToken = JSON.parse(atob(response.data.token.split('.')[1]));
        localStorage.setItem('user', JSON.stringify(decodedToken));
    }
    return response.data;
};

const logout = () => { // OK
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};

const getCurrentUser = () => { // OK
    return JSON.parse(localStorage.getItem('user'));
};

export default {
    login,
    logout,
    getCurrentUser
   
};